module.exports = __webpack_public_path__ + "img/bg1.48d4795d.jpg";